import { createFileRoute, notFound } from "@tanstack/react-router";

import { ArticlePage } from "@/components/blog/ArticlePage";
import { BlogListing } from "@/components/blog/BlogListing";
import { JsonLd } from "@/components/seo/JsonLd";
import { carregarArtigo } from "@/lib/artigo-page";
import { carregarPaginaBlog } from "@/lib/blog-page";
import { breadcrumbSchema } from "@/lib/schema";

/**
 * Categoria e artigo dividem o mesmo padrão de URL, /blog/{slug}/.
 * O slug é resolvido no servidor: se for categoria, a página é a listagem; se
 * for artigo publicado, é o artigo; se não for nenhum dos dois, responde 404.
 */
export const Route = createFileRoute("/blog/$categoria/")({
  loader: async ({ params }) => {
    const path = `/blog/${params.categoria}/`;
    const listagem = await carregarPaginaBlog({
      categoria: params.categoria,
      pagina: 1,
      path,
      semErro: true,
    });
    if (listagem) return { tipo: "categoria" as const, ...listagem };

    const artigo = await carregarArtigo({ slug: params.categoria, path });
    if (artigo) return { tipo: "artigo" as const, ...artigo };

    throw notFound();
  },
  head: ({ loaderData }) => ({ meta: loaderData?.meta ?? [] }),
  component: Pagina,
});

function Pagina() {
  const dados = Route.useLoaderData();

  if (dados.tipo === "artigo") {
    return (
      <>
        <ArticlePage
          artigo={dados.artigo}
          doctor={dados.doctor}
          bio={dados.bio}
          trilha={dados.trilha}
        />
        {dados.schemas.map((schema, indice) => (
          <JsonLd key={`schema-${indice}`} data={schema} />
        ))}
      </>
    );
  }

  return (
    <>
      <BlogListing
        dados={dados.dados}
        h1={dados.h1}
        subtitulo={dados.subtitulo}
        trilha={dados.trilha}
      />
      <JsonLd data={breadcrumbSchema(dados.trilha.filter((item) => item.nome !== "Conteúdos"))} />
    </>
  );
}
